import React from 'react';
import { Table, ProgressBar } from 'react-bootstrap';
import './AttendanceTable.css';

const statusClass = status => {
  if (status === 'Present') return 'present';
  if (status === 'Away') return 'away';
  return 'absent';
};

const AttendanceTable = ({ records }) => (
  <Table hover responsive className="attendance-table">
    <thead>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Check-in</th>
        <th>Check-out</th>
        <th>Work %</th>
        <th>Overtime %</th>
      </tr>
    </thead>
    <tbody>
      {records.map(rec => (
        <tr key={rec.id}>
          <td>{rec.id}</td>
          <td>{rec.name}</td>
          <td>{rec.checkIn}</td>
          <td>{rec.checkOut}</td>
          <td>
            <ProgressBar now={rec.workedPerc} label={`${rec.workedPerc}%`} variant="primary" />
          </td>
          <td>
            <ProgressBar now={rec.overtimePerc} label={`${rec.overtimePerc}%`} variant="warning" />
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default AttendanceTable;